import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=6754569e&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=ts&"
export * from "./Collection.vue?vue&type=script&lang=ts&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=6754569e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754569e",
  null
  
)

export default component.exports